// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styling-product-design-container {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 100px;
  background-color: #f5f5f5;
  border-radius: 8px;
  font-family: Arial, sans-serif;

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 20px;
  margin-top: 0;
}

.styling-product-design-image {
  position: relative;
  width: 35%;
  order: 2;
  padding: 10px 0;
  margin-top: -20px;
}

.services-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.styling-product-design-text {
  width: 65%;
  order: 2;
  margin-top: -90px;
}

.styling-product-design-text h1 {
  font-size: 2rem;
  color: #000;
  margin-bottom: 10px;
}

div.styling-product-design-text p {
  font-size: 1.2em;
  color: #555;
  margin-bottom: 20px;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  padding: 0;
}

.services-list li {
  width: 45%;
  font-size: 1rem;
  color: #333;
}

@media (max-width: 768px) {
  .styling-product-design-container {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    gap: 20px;
    padding: 20px;
    padding-top: 30px;
  }

  .styling-product-design-text {
    width: 100%;
    order: 2;
    margin-bottom: 30px;
    margin-top: -60px;
  }

  .styling-product-design-image {
    margin-top: 120px;
    width: 100%;
    order: 1;
  }

  .services-list li {
    width: 100%;
  }
}

@media screen and (min-width: 1380px) and (max-width: 1919px) {
  .styling-product-design-container {
    padding: 100px;
    gap: 15px;
  }

  .styling-product-design-text {
    margin-top: -80px;
  }

  .styling-product-design-text h1 {
    font-size: 1.8rem;
  }

  div.styling-product-design-text p {
    font-size: 0.9rem;
  }

  .styling-product-design-image {
    width: 28%;
    margin-top: -20px;
  }

  .services-list li {
    width: 48%;
    font-size: 0.9rem;
  }
}

@media screen and (min-width: 1920px) {
  .styling-product-design-container {
    padding: 100px;
    gap: 25px;
  }

  .styling-product-design-text {
    margin-top: -100px;
  }

  .styling-product-design-text h1 {
    font-size: 2.2rem;
  }

  div.styling-product-design-text p {
    font-size: 1.1rem;
  }

  .styling-product-design-image {
    width: 33%;
    margin-top: -30px;
  }

  .services-list li {
    width: 45%;
    font-size: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StylingProductDesign/StylingProductDesign.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;;EAE9B,wCAAwC;EACxC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF","sourcesContent":[".styling-product-design-container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 100px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  font-family: Arial, sans-serif;\n\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  gap: 20px;\n  margin-top: 0;\n}\n\n.styling-product-design-image {\n  position: relative;\n  width: 35%;\n  order: 2;\n  padding: 10px 0;\n  margin-top: -20px;\n}\n\n.services-image {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.styling-product-design-text {\n  width: 65%;\n  order: 2;\n  margin-top: -90px;\n}\n\n.styling-product-design-text h1 {\n  font-size: 2rem;\n  color: #000;\n  margin-bottom: 10px;\n}\n\ndiv.styling-product-design-text p {\n  font-size: 1.2em;\n  color: #555;\n  margin-bottom: 20px;\n}\n\n.services-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  list-style: none;\n  padding: 0;\n}\n\n.services-list li {\n  width: 45%;\n  font-size: 1rem;\n  color: #333;\n}\n\n@media (max-width: 768px) {\n  .styling-product-design-container {\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n    gap: 20px;\n    padding: 20px;\n    padding-top: 30px;\n  }\n\n  .styling-product-design-text {\n    width: 100%;\n    order: 2;\n    margin-bottom: 30px;\n    margin-top: -60px;\n  }\n\n  .styling-product-design-image {\n    margin-top: 120px;\n    width: 100%;\n    order: 1;\n  }\n\n  .services-list li {\n    width: 100%;\n  }\n}\n\n@media screen and (min-width: 1380px) and (max-width: 1919px) {\n  .styling-product-design-container {\n    padding: 100px;\n    gap: 15px;\n  }\n\n  .styling-product-design-text {\n    margin-top: -80px;\n  }\n\n  .styling-product-design-text h1 {\n    font-size: 1.8rem;\n  }\n\n  div.styling-product-design-text p {\n    font-size: 0.9rem;\n  }\n\n  .styling-product-design-image {\n    width: 28%;\n    margin-top: -20px;\n  }\n\n  .services-list li {\n    width: 48%;\n    font-size: 0.9rem;\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .styling-product-design-container {\n    padding: 100px;\n    gap: 25px;\n  }\n\n  .styling-product-design-text {\n    margin-top: -100px;\n  }\n\n  .styling-product-design-text h1 {\n    font-size: 2.2rem;\n  }\n\n  div.styling-product-design-text p {\n    font-size: 1.1rem;\n  }\n\n  .styling-product-design-image {\n    width: 33%;\n    margin-top: -30px;\n  }\n\n  .services-list li {\n    width: 45%;\n    font-size: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
